/* Real app films (.clip), shared by the homepage and the Software page.
   The films are the owner's own app design (Virtusx Simulator, Recording v2) filmed by website/_dev/record_*.py
   and cut by make_app_clips.py into assets/video/app/.
   Markup: <div class="clip"><img src="still.jpg" alt="..."><video muted loop playsinline preload="none"
             data-src="film.mp4" [data-src-m="phone-cut.mp4"] aria-hidden="true"></video></div>
   The still (the finished state) shows first; the film loads when near, plays only while on screen and fades in
   once it really plays. A film inside a closed tab panel (.hab-pop without .on) waits until its panel opens;
   a 'habit' event on document re-checks them. Reduced motion: only the stills.
   The still is the film's last moment, and every film ends by dissolving back to its first frame (make_app_clips.py,
   loop_fade 0.5 s): so a film starts just before that dissolve, and the still turns into the film with no jump. */
(function(){
  if(!('IntersectionObserver' in window))return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var phone=matchMedia('(max-width:720px)');
  function src(v){return phone.matches&&v.dataset.srcM?v.dataset.srcM:v.dataset.src}
  function load(v){
    if(v.dataset.on)return;v.dataset.on='1';
    v.addEventListener('playing',function(){v.parentNode.classList.add('playing')});
    v.addEventListener('error',function(){v.remove()},{once:true});
    v.addEventListener('loadedmetadata',function(){if(v.duration>2&&!v.currentTime)v.currentTime=v.duration-.55},{once:true});
    v.preload='auto';v.src=src(v);v.load();
  }
  function wanted(v){var pop=v.closest('.hab-pop');return v.dataset.seen==='1'&&(!pop||pop.classList.contains('on'))}
  function sync(v){if(wanted(v)){load(v);v.play().catch(function(){})}else if(v.dataset.on)v.pause()}
  var near=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)load(e.target)})},{rootMargin:'300px'});
  var seen=new IntersectionObserver(function(es){es.forEach(function(e){e.target.dataset.seen=e.isIntersecting?'1':'0';sync(e.target)})},{threshold:.1});
  var vids=[].slice.call(document.querySelectorAll('.clip > video[data-src]'));
  vids.forEach(function(v){if(!v.closest('.hab-pop:not(.on)'))near.observe(v);seen.observe(v)});
  // a tab panel opened: its film starts from the beginning, the others stop
  document.addEventListener('habit',function(){vids.forEach(function(v){if(v.closest('.hab-pop.on')&&v.dataset.on&&v.dataset.seen==='1')v.currentTime=0;sync(v)})});
})();
